import AngleRight from '@/components/pd-angle-right/pd-angle-right'
import { useMobileDetector } from '@hooks/use-mobile-detector'
import { CustomerCase } from '@/service/customer-new.service'
import { useTranslations } from 'next-intl'
import SlidingTabContent from '@components/standard/sliding-tab-content'
import CaseCard from '@components/standard/case-card'
import clsx from 'clsx'
import Link from 'next/link'

interface Section4Props {
  data: {
    otherCaseCards?: CustomerCase[]
    otherCaseStudiesTitle?: string
    otherCaseStudiesMoreTitle?: string
  }
}

const Section4 = ({ data }: Section4Props) => {
  const t = useTranslations()
  const isMobileDevice = useMobileDetector()
  const { otherCaseCards, otherCaseStudiesTitle, otherCaseStudiesMoreTitle } = data

  return (
    <div className="w-full py-15 laptop:py-30 bg-pdbg">
      <div className="overflow-hidden">
        <div className="max-w-300 mx-auto px-6 laptop:px-0 flex justify-between items-center mb-8 laptop:mb-16">
          <h1 className="text-black/90 text-2xl laptop:text-5xl font-medium">{otherCaseStudiesTitle}</h1>
          {!isMobileDevice && (
            <Link href={'/case-studies'} passHref>
              <a className="text-blue-600 text-sm laptop:text-base font-normal flex items-center gap-1">
                <span>{otherCaseStudiesMoreTitle}</span>
                <AngleRight theme="PUDUBLUE" size="4x8" />
              </a>
            </Link>
          )}
        </div>
        {otherCaseCards && otherCaseCards?.length > 0 && (
          <SlidingTabContent data={otherCaseCards} boxClassName="max-w-300 mx-auto px-6 laptop:px-0">
            <CaseCard mini={true} boxClassName={clsx('!w-72 h-322px', 'laptop:!w-110')} />
          </SlidingTabContent>
        )}
      </div>
    </div>
  )
}

export default Section4
